/**
 * Spec-count display normalization (#997): Central returns counts as strings
 * with PMS-flavored decimals ("2.0" bathrooms) — rendered verbatim they read
 * as "2.0 BATHROOMS". Round-tripping through Number drops a trailing .0 while
 * preserving real halves ("1.5" stays "1.5").
 */
export function formatSpecCount(value: unknown): string {
  const n = Number(value)
  return Number.isFinite(n) ? String(n) : '0'
}

/** Numeric view of the same value, for zero/positive branching (#998 studio). */
export function specCountValue(value: unknown): number {
  const n = Number(value)
  return Number.isFinite(n) ? n : 0
}
